// extracted by mini-css-extract-plugin
module.exports = {"currentVersionText":"VersionInformation-module--currentVersionText--2wUBo"};